module.exports = __webpack_public_path__ + "media/entities/6004-62f1b883.png";